import ParticipantServiceFamily, {IParticipantServiceFamily} from "@/model/ServiceFamily/ParticipantServiceFamily"

export interface IRestaurationServiceFamily extends IParticipantServiceFamily {

}

class RestaurationServiceFamily extends ParticipantServiceFamily implements IRestaurationServiceFamily {
    
    constructor(id: string) {
        super(id)
    }
}

export default RestaurationServiceFamily